import axios from "axios";
import { BASE_API_URL } from "../consts";

export interface WorkLocation {
  _id: string;
  name: string;
  clientId: string;
  frozen?: boolean;
  frozenAt?: string | null;
}

export interface AssignWorkLocationsRequest {
  userId: string;
  locationIds: string[];
}

export interface WorkLocationsResponse {
  workLocations: WorkLocation[];
}

export const workLocationsAPI = {
  /**
   * Get user's work locations
   */
  getUserWorkLocations: async (
    userId: string,
    token: string
  ): Promise<WorkLocationsResponse> => {
    const response = await axios.get(
      `${BASE_API_URL}/user/${userId}/work-locations`,
      {
        headers: {
          "x-access-token": token,
        },
      }
    );
    return response.data;
  },

  /**
   * Assign work locations to user
   */
  assignWorkLocations: async (
    data: AssignWorkLocationsRequest,
    token: string
  ): Promise<WorkLocationsResponse> => {
    const response = await axios.put(
      `${BASE_API_URL}/user/work-locations`,
      data,
      {
        headers: {
          "x-access-token": token,
        },
      }
    );
    return response.data;
  },

  /**
   * Get all locations for a client
   */
  getClientLocations: async (
    clientId: string,
    token: string
  ): Promise<WorkLocation[]> => {
    const response = await axios.get(`${BASE_API_URL}/${clientId}/locations`, {
      headers: {
        "x-access-token": token,
      },
    });
    return response.data;
  },
};
